(function () {
  var root = document.querySelector("[data-faq-shojiki-root]");
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-model-tab]"));
  var panels = Array.prototype.slice.call(root.querySelectorAll("[data-model-panel]"));

  function activateModel(model) {
    tabs.forEach(function (tab) {
      var active = tab.dataset.modelTab === model;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-pressed", active ? "true" : "false");
    });
    panels.forEach(function (panel) {
      panel.classList.toggle("is-active", panel.dataset.modelPanel === model);
    });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("m", model);
      window.history.replaceState(null, "", url.toString());
    } catch (e) {}
  }

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      activateModel(tab.dataset.modelTab);
    });
  });

  var initialModel = (function () {
    try {
      var url = new URL(window.location.href);
      var m = url.searchParams.get("m");
      if (m && panels.some(function (p) { return p.dataset.modelPanel === m; })) return m;
    } catch (e) {}
    var def = root.dataset.faqShojikiDefault;
    return def || (panels[0] && panels[0].dataset.modelPanel) || "sh-j001";
  })();
  activateModel(initialModel);

  panels.forEach(initPanel);

  function initPanel(panel) {
    var search = panel.querySelector("[data-faq-search]");
    var chips = Array.prototype.slice.call(panel.querySelectorAll("[data-filter]"));
    var categories = Array.prototype.slice.call(panel.querySelectorAll("[data-category]"));
    var items = Array.prototype.slice.call(panel.querySelectorAll("[data-faq-item]"));
    var noResults = panel.querySelector("[data-no-results]");
    var activeCategory = "all";

    function textOf(element) {
      return element.textContent.replace(/\s+/g, " ").trim().toLowerCase();
    }

    function escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function clearHighlights(item) {
      var marks = item.querySelectorAll("mark.hl");
      for (var i = 0; i < marks.length; i++) {
        var mark = marks[i];
        var parent = mark.parentNode;
        parent.replaceChild(document.createTextNode(mark.textContent), mark);
        parent.normalize();
      }
    }

    function highlightInNode(node, regex) {
      if (!node || node.nodeType !== 3) return;
      var match = regex.exec(node.nodeValue);
      if (!match) return;
      var before = node.splitText(match.index);
      var after = before.splitText(match[0].length);
      var mark = document.createElement("mark");
      mark.className = "hl";
      mark.appendChild(document.createTextNode(before.nodeValue));
      before.parentNode.replaceChild(mark, before);
      highlightInNode(after, regex);
    }

    function highlightItem(item, query) {
      if (!query) return;
      var regex = new RegExp(escapeRegex(query), "i");
      var targets = item.querySelectorAll("summary, .answer");
      for (var i = 0; i < targets.length; i++) {
        var walker = document.createTreeWalker(targets[i], NodeFilter.SHOW_TEXT, null);
        var nodes = [];
        while (walker.nextNode()) {
          var n = walker.currentNode;
          if (n.parentNode && n.parentNode.nodeName !== "MARK") nodes.push(n);
        }
        for (var j = 0; j < nodes.length; j++) {
          highlightInNode(nodes[j], regex);
        }
      }
    }

    function applyFilter() {
      var query = search ? search.value.trim().toLowerCase() : "";
      var visibleCount = 0;

      items.forEach(function (item) {
        clearHighlights(item);
        var matchesCategory = activeCategory === "all" || item.dataset.faqCategory === activeCategory;
        var matchesQuery = !query || textOf(item).indexOf(query) !== -1;
        var visible = matchesCategory && matchesQuery;
        item.classList.toggle("is-hidden", !visible);
        if (visible) {
          visibleCount += 1;
          if (query) highlightItem(item, query);
        } else {
          item.open = false;
        }
      });

      categories.forEach(function (category) {
        var hasVisible = Array.prototype.some.call(
          category.querySelectorAll("[data-faq-item]"),
          function (item) { return !item.classList.contains("is-hidden"); }
        );
        category.classList.toggle("is-hidden", !hasVisible);
      });

      if (noResults) {
        noResults.classList.toggle("is-hidden", visibleCount !== 0);
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        activeCategory = chip.dataset.filter;
        chips.forEach(function (other) {
          var active = other === chip;
          other.classList.toggle("is-active", active);
          other.setAttribute("aria-pressed", active ? "true" : "false");
        });
        applyFilter();
      });
    });

    if (search) {
      search.addEventListener("input", applyFilter);
    }

    // --- #T-063-C 症状ボタン: 該当の質問へジャンプして開く ---
    var symptoms = Array.prototype.slice.call(panel.querySelectorAll("[data-symptom-target]"));
    var jumpTimer = null;

    symptoms.forEach(function (button) {
      var id = button.getAttribute("data-symptom-target");
      var target = document.getElementById(id);

      // 対応する質問がまだ無い場合はボタンを出さない(データ投入前・並び変更時の安全弁)
      if (!target) {
        button.hidden = true;
        return;
      }

      button.addEventListener("click", function () {
        // 絞り込みが効いていると飛び先が隠れるため、いったん全表示に戻す
        if (search) search.value = "";
        activeCategory = "all";
        chips.forEach(function (chip) {
          var isAll = chip.dataset.filter === "all";
          chip.classList.toggle("is-active", isAll);
          chip.setAttribute("aria-pressed", isAll ? "true" : "false");
        });
        applyFilter();

        symptoms.forEach(function (other) {
          other.classList.toggle("is-target", other === button);
        });

        target.open = true;
        target.scrollIntoView({ behavior: "smooth", block: "start" });

        target.classList.add("is-jumped");
        if (jumpTimer) clearTimeout(jumpTimer);
        jumpTimer = setTimeout(function () {
          target.classList.remove("is-jumped");
        }, 1600);
      });
    });
  }
})();
